import { useEffect, useState } from 'react';

/**
 * Returns a value that follows `value` after `delayMs` of no changes.
 * Replaces the historical `window.__searchTimeout` pattern: each
 * component mount gets its own timer (no global key collisions).
 */
export function useDebouncedValue<T>(value: T, delayMs: number): T {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const id = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(id);
  }, [value, delayMs]);

  return debounced;
}
